if (!customElements.get('mobile-menu-tab')) {
  customElements.define('mobile-menu-tab', class MobileMenuTab extends HTMLElement {
    constructor() {
      super();

      this.menuItems = this.querySelectorAll('[data-menu-item]');
      this.menuImages = this.querySelectorAll('[data-menu-image]');

      this.menuItems.forEach((item) => {
        const matchedImage = item.dataset.menuItem;
        const image = item.querySelector(`[data-menu-image="${matchedImage}"]`)
        if (image) {
          image.style.display = 'flex';
        }
      });
    }
  });
}
